import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  TextAreaItem,
  CheckItem,
  ErrorItem,
} from "../../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import ordenDeMaquilaPdf from "../../../../../Pdf/ordenDeMaquilaPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class MandarCorreoOrdenDeMaquila extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    totalArchivos: 0,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) this.consultarTodo();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "ordenesDeMaquila/datosPdf",
        { ordenDeMaquilaId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const pdf = pdfMake.createPdf(ordenDeMaquilaPdf(res.data));
          this.setState({ loading: false, totalArchivos: (res.data.ordenDeMaquila?.archivos || []).length }, () => {
            pdf.open({}, window.frames["ordenDeMaquilaPdf"]);
          });
        } else {
          this.cerrarModal();
          message.warning("No se pudo cargar la orden de maquila");
        }
      });
    this.setState({ loading: false });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (values?.correosEnvio?.length > 0) {
      this.setState({ loading: true });
      axios
        .post(
          "ordenesDeMaquila/enviarCorreo",
          { ...values, ordenDeMaquilaId: this.props.id, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Orden de maquila enviada");
            this.formRef.current.resetFields();
            this.cerrarModal();
          } else if (res.data.success === 1) {
            message.error(res.data.message || "No se pudo enviar la orden de maquila a ese correo");
          } else {
            message.error("Sucedió un error y no se pudo enviar");
          }
        });
    } else {
      message.info("Proporcione al menos un correo de envío");
    }
  }

  cerrarModal() {
    this.props.onCerrar();
    this.formRef.current.resetFields();
  }

  descargarPdf() {
    axios
      .post(
        "ordenesDeMaquila/datosPdf",
        { ordenDeMaquilaId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) return message.warning("No se pudo cargar la orden de maquila");
        const nombreArchivo = `Orden de Maquila ${res.data.ordenDeMaquila.folio || ""}`;
        pdfMake.createPdf(ordenDeMaquilaPdf(res.data)).download(nombreArchivo + ".pdf");
      });
  }

  render() {
    return (
      <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="mandarCorreoOrdenDeMaquila"
          layout
          width={700}
          onCancel={this.cerrarModal.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List name="correosEnvio" initialValue={[{ correo: "" }]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={arrayKey}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: "100%" }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: "center", marginTop: "5px" }}>
                    <ButtonItem type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>
          <FormItem name="mensaje" label="Mensaje" margin>
            <TextAreaItem placeholder="Mensaje que acompaña al correo (opcional)" rows={2} />
          </FormItem>
          {/* Quien manda decide si van los archivos de la orden (planos pesados, etc.). */}
          {this.state.totalArchivos > 0 && (
            <FormItem name="incluirArchivos" valuePropName="checked" initialValue={false} margin>
              <CheckItem>
                {this.state.totalArchivos === 1
                  ? "Incluir el archivo adjunto de la orden"
                  : `Incluir los ${this.state.totalArchivos} archivos adjuntos de la orden`}
              </CheckItem>
            </FormItem>
          )}
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem
                type="primary"
                blanco={true}
                onClick={this.descargarPdf.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Descargar
              </ButtonItem>
              <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarModal.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
        <iframe
          title="ordenDeMaquilaPdf"
          style={{ width: "100%", height: "100vh" }}
          id="ordenDeMaquilaPdf"
          name="ordenDeMaquilaPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(MandarCorreoOrdenDeMaquila);
